import React from "react";
import { Box, Typography, Container, Stack, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate("/dashboard");
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          textAlign: "center",
          py: 4,
        }}
      >
        {/* Error Icon and Code */}
        <Box sx={{ mb: 3 }}>
          <SearchIcon
            sx={{
              fontSize: 120,
              color: "#3C6EEF",
              opacity: 0.7,
              mb: 2,
            }}
          />
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "4rem", md: "6rem" },
              fontWeight: 700,
              color: "#0C2F49",
              lineHeight: 1,
              mb: 1,
            }}
          >
            404
          </Typography>
        </Box>

        {/* Error Message */}
        <Stack spacing={2} sx={{ mb: 4, maxWidth: 500 }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 600,
              color: "#0C2F49",
            }}
          >
            Setting Page Not Found
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.1rem",
              color: "#0C2F49",
              opacity: 0.8,
              lineHeight: 1.6,
            }}
          >
            The settings page you're looking for doesn't exist or has been
            moved. Please check the URL or navigate back to available settings.
          </Typography>
        </Stack>

        {/* Action Buttons */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ width: "100%", maxWidth: 400 }}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<SettingsIcon />}
            onClick={handleGoBack}
            sx={{
              backgroundColor: "#3C6EEF",
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 500,
              py: 1.5,
              "&:hover": {
                backgroundColor: "#2854CC",
              },
            }}
          >
            Go Back to Settings
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{
              borderColor: "#3C6EEF",
              color: "#3C6EEF",
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 500,
              py: 1.5,
              "&:hover": {
                borderColor: "#2854CC",
                backgroundColor: "rgba(60, 110, 239, 0.04)",
              },
            }}
          >
            Go to Dashboard
          </Button>
        </Stack>

        {/* Additional Help Text */}
        <Box
          sx={{
            mt: 4,
            p: 3,
            backgroundColor: "#F6F8FC",
            borderRadius: 2,
            maxWidth: 500,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#0C2F49",
              opacity: 0.7,
              fontSize: "0.9rem",
            }}
          >
            <strong>Need help?</strong> If you believe this is an error, please
            contact your system administrator or check if you have the proper
            permissions to access this settings page.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;
